import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { LanguageContext } from '../LanguageContext'; 

function BlogSection() {
  const { language } = useContext(LanguageContext); 
  const blog1 = require('../img/blog-thumb01.jpg');
  const blog2 = require('../img/blog-thumb02.jpg');
  const blog3 = require('../img/blog-thumb03.jpg');




  const articlesData = {
    fr: [
      {
        id: 'preparer-omra',
        title: 'Préparer Spirituellement Votre Omra',
        summary: 'Découvrez des conseils essentiels pour vous préparer spirituellement à votre voyage Omra...',
        image: blog1,
      },
      {
        id: 'etapes-omra',
        title: 'Les Étapes Clés de la Omra Expliquées',
        summary: 'Un guide clair et détaillé des étapes rituelles de la Omra...',
        image: blog2,
      },
      {
        id: 'conseils-voyage',
        title: 'Conseils Pratiques pour un Voyage Omra Réussi',
        summary: 'Maximisez votre expérience Omra avec ces conseils pratiques...',
        image: blog3,
      }
    ],
    ar: [
      {
        id: 'preparer-omra',
        title: 'الاستعداد الروحي لعمرتك',
        summary: 'اكتشف النصائح الأساسية للاستعداد الروحي لرحلة العمرة...',
        image: blog1,
      },
      {
        id: 'etapes-omra',
        title: 'الخطوات الرئيسية للعمرة موضحة',
        summary: 'دليل واضح ومفصل لخطوات العمرة...',
        image: blog2,
      },
      {
        id: 'conseils-voyage',
        title: 'نصائح عملية لرحلة عمرة ناجحة',
        summary: 'قم بتحسين تجربة عمرتك مع هذه النصائح العملية...',
        image: blog3,
      }
    ]
  };

  const content = {
    fr: {
      title: 'Conseils et Articles pour Votre Omra',
      readMore: 'Lire la suite'
    },
    ar: {
      title: 'نصائح ومقالات لعمرتك',
      readMore: 'اقرأ المزيد'
    }
  };

  return (
    <section className="py-20 bg-gradient-to-r from-blue-50 via-green-100 to-blue-50">
      <div className="container mx-auto px-6">
        <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center hover:text-green-600 transition-colors duration-300">
          {content[language].title}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {articlesData[language].map((article, index) => (
            <div 
              key={index} 
              className="bg-white shadow-lg rounded-xl overflow-hidden hover:shadow-2xl transition-transform duration-300"
            >
              <img 
                src={article.image} 
                alt={article.title} 
                className="w-full h-56 object-cover"
              />
              <div className="px-6 py-6">
                <h3 className="text-xl font-bold text-gray-800 mb-3">{article.title}</h3>
                <p className="text-gray-600 text-base mb-4">{article.summary}</p>
                <div className="text-sm text-gray-500 mb-4">{article.date}</div>
                <Link
                  to={`/blog/${article.id}`}
                  className="inline-block mt-2 bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded-md transition-colors duration-300"
                >
                  {content[language].readMore}
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default BlogSection;